import ReportsPage from "components/Reports/Pages/Reports";

function ChainReports() {
    return (
        <>
            <ReportsPage userType={3} />
        </>
    )
}

export default ChainReports;
